@import '../../vars.css';

.highlighted {
    background: var(--modal-header-highlight-background);
    box-shadow: var(--modal-header-highlight-box-shadow);
}

.sticky {
    position: sticky;
    z-index: 1;

    &.hasContent {
        background: var(--modal-header-background);
    }
}
